import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import workflows from './modules/workflows'
import forms from './modules/form'
import api from './modules/api'
import config from './modules/config'
import ui from './modules/user-interface'
import skins from './modules/skins'
import notifications from './modules/notifications'
import dynamicWorkflows from './modules/dynamic-workflows'
import table from './modules/table'
import navigation from './modules/navigation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { forms, api, ui, skins, notifications, dynamicWorkflows, table, workflows, navigation, config }
})



// WEBPACK FOOTER //
// ./src/vuex/Store.js